// @ts-check

import React from "react";

import { Banner, BlockStack, Text } from "@shopify/polaris";
import { RefreshIcon } from "@shopify/polaris-icons";

import { useGlobalContext } from "context/GlobalContext";

export const SyncingBanner = () => {
  const {
    syncing,
    refetchStore,
    isRefetchingStore,
    refetchOrders,
    isFetchingOrders,
  } = useGlobalContext();

  const handleRefetch = () => {
    refetchOrders();
    refetchStore();
  };

  if (!syncing) {
    return null;
  }

  return (
    <Banner
      title="Syncing order data"
      tone="warning"
      action={{
        content: "Refresh",
        loading: isFetchingOrders || isRefetchingStore,
        onAction: handleRefetch,
        icon: RefreshIcon,
      }}
      secondaryAction={{
        content: "Contact us",
        onAction: () => window.$crisp.push(["do", "chat:open"]),
      }}
    >
      <BlockStack gap="200">
        <Text as="p" variant="bodyMd">We're currently importing all of your past order data.</Text>

        <Text as="p" variant="bodyMd">
          Depending on your shop history this could take up to 30 minutes to complete.
          If you don't see all your data available after this time, please contact us and we'll be
          happy to help!
        </Text>
      </BlockStack>
    </Banner>
  );
};
